<template>
  <div class="panel">
    <div class="panel-title" :style="{ background: titleBg }">
      <div class="title-left">
        <slot name="title">面板标题</slot>
      </div>
      <div :class="['title-right', 'pointer', {'rotate': !isClose}]" @click="handlePanel(isClose)">
        <i :class="['el-icon-arrow-down']"></i>
      </div>
    </div>
    <div :class="['panel-content', { 'closed': isClose }]">
      <slot class="no-data">
        暂无数据
      </slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FoldedPanel',
  props: {
    titleBg: {
      type: String,
      default: '#eee'
    },
    isClose: {
      type: Boolean,
      default: false
    },
    // 主动折叠
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  created() {
  },
  watch: {
    isClose(val) {
      this.$emit('update:isClose', !val)
    }
  },
  methods: {
    handlePanel(flag) {
      if(!this.isActive) {
        this.isClose = !flag
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.panel {
  width: 100%;
  border-radius: 6px;
  box-shadow: 0 0 2px 1px #ccc;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all .5s;
  margin-bottom: 20px;
  .panel-title {
    background: #eee;
    height: 35px;
    display: flex;
    justify-content: space-between;
    padding: 10px;
    align-items: center;
    font-size: 16px;
    .title-left {
      flex: 1;
    }
    .title-right {
      width: 35px;
      height: 35px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
    .rotate {
      transform: rotate(180deg);
    }
  }
  
  .panel-content {
    width: 100%;
    // flex: 1;
    flex-shrink: 0;
    padding: 0 10px;
    &.closed {
      height: 0px;
    }
  }
}

</style>
